'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dGrocery$002dItem$002dSort$002dType from "./mealorama.-Grocery-Item-Sort-Type.js";
import * as $j_mealorama$002e$002dGrocery$002dItem$002dSort$002dType$0024$0024anon$00242 from "./mealorama.-Grocery-Item-Sort-Type$$anon$2.js";
var $p;
function $s_Lmealorama_GroceryItemSortType$__name__Lmealorama_GroceryItemSortType() {
  $m_Lmealorama_GroceryItemSortType$();
  return $t_Lmealorama_GroceryItemSortType$__name;
}
export { $s_Lmealorama_GroceryItemSortType$__name__Lmealorama_GroceryItemSortType as $s_Lmealorama_GroceryItemSortType$__name__Lmealorama_GroceryItemSortType };
function $s_Lmealorama_GroceryItemSortType$__length__Lmealorama_GroceryItemSortType() {
  $m_Lmealorama_GroceryItemSortType$();
  return $t_Lmealorama_GroceryItemSortType$__length;
}
export { $s_Lmealorama_GroceryItemSortType$__length__Lmealorama_GroceryItemSortType as $s_Lmealorama_GroceryItemSortType$__length__Lmealorama_GroceryItemSortType };
/** @constructor */
function $c_Lmealorama_GroceryItemSortType$() {
  this.alJ = null;
  $n_Lmealorama_GroceryItemSortType$ = this;
  $t_Lmealorama_GroceryItemSortType$__name = new $j_mealorama$002e$002dGrocery$002dItem$002dSort$002dType$0024$0024anon$00242.$c_Lmealorama_GroceryItemSortType$$anon$2("name", 0);
  $t_Lmealorama_GroceryItemSortType$__length = new $j_mealorama$002e$002dGrocery$002dItem$002dSort$002dType$0024$0024anon$00242.$c_Lmealorama_GroceryItemSortType$$anon$2("length", 1);
  this.alJ = new ($j_mealorama$002e$002dGrocery$002dItem$002dSort$002dType.$d_Lmealorama_GroceryItemSortType.r().C)([$s_Lmealorama_GroceryItemSortType$__name__Lmealorama_GroceryItemSortType(), $s_Lmealorama_GroceryItemSortType$__length__Lmealorama_GroceryItemSortType()]);
}
export { $c_Lmealorama_GroceryItemSortType$ as $c_Lmealorama_GroceryItemSortType$ };
$p = $c_Lmealorama_GroceryItemSortType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItemSortType$;
/** @constructor */
function $h_Lmealorama_GroceryItemSortType$() {
}
export { $h_Lmealorama_GroceryItemSortType$ as $h_Lmealorama_GroceryItemSortType$ };
$h_Lmealorama_GroceryItemSortType$.prototype = $p;
$p.b6u = (function() {
  return this.alJ.a6();
});
var $d_Lmealorama_GroceryItemSortType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_GroceryItemSortType$, "mealorama.GroceryItemSortType$", ({
  FO: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_GroceryItemSortType$ as $d_Lmealorama_GroceryItemSortType$ };
var $n_Lmealorama_GroceryItemSortType$;
function $m_Lmealorama_GroceryItemSortType$() {
  if ((!$n_Lmealorama_GroceryItemSortType$)) {
    $n_Lmealorama_GroceryItemSortType$ = new $c_Lmealorama_GroceryItemSortType$();
  }
  return $n_Lmealorama_GroceryItemSortType$;
}
export { $m_Lmealorama_GroceryItemSortType$ as $m_Lmealorama_GroceryItemSortType$ };
var $t_Lmealorama_GroceryItemSortType$__name = null;
function $u_Lmealorama_GroceryItemSortType$__name(x) {
  $t_Lmealorama_GroceryItemSortType$__name = x;
}
export { $t_Lmealorama_GroceryItemSortType$__name as $t_Lmealorama_GroceryItemSortType$__name, $u_Lmealorama_GroceryItemSortType$__name as $u_Lmealorama_GroceryItemSortType$__name };
var $t_Lmealorama_GroceryItemSortType$__length = null;
function $u_Lmealorama_GroceryItemSortType$__length(x) {
  $t_Lmealorama_GroceryItemSortType$__length = x;
}
export { $t_Lmealorama_GroceryItemSortType$__length as $t_Lmealorama_GroceryItemSortType$__length, $u_Lmealorama_GroceryItemSortType$__length as $u_Lmealorama_GroceryItemSortType$__length };
//# sourceMappingURL=mealorama.-Grocery-Item-Sort-Type$.js.map
